import { render, staticRenderFns } from "./profile-new-organization-booking.vue?vue&type=template&id=50b0e160&scoped=true&"
import script from "./profile-new-organization-booking.ts?vue&type=script&lang=ts&"
export * from "./profile-new-organization-booking.ts?vue&type=script&lang=ts&"
import style0 from "./profile-new-organization-booking.scss?vue&type=style&index=0&id=50b0e160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0e160",
  null
  
)

export default component.exports